import AuthGuard from "../../auth/AuthGuard";
import { ErrorLayout } from "../../components/ErrorLayout";
import CommonLayout from "../../layouts/common/CommonLayout";

// Give every child route its own error boundary so a crash is contained to the
// content area and CommonLayout's navigation survives — the user can still
// navigate away instead of being stranded. A route that declares its own
// errorElement keeps it. The layout route also gets one, as a fallback for
// errors thrown by AuthGuard/CommonLayout themselves.
export const withErrorBoundary = (routes = []) =>
  routes.map((route) => ({
    errorElement: <ErrorLayout contained />,
    ...route,
  }));

export const authLayout = (title, children) => ({
  element: (
    <AuthGuard>
      <CommonLayout title={title} />
    </AuthGuard>
  ),
  errorElement: <ErrorLayout />,
  children: withErrorBoundary(children),
});

export const adminLayout = (title, children) => ({
  element: (
    <AuthGuard allowedRoles={["admin", "superAdmin"]}>
      <CommonLayout title={title} />
    </AuthGuard>
  ),
  errorElement: <ErrorLayout />,
  children: withErrorBoundary(children),
});
